export enum EventStatusEnum {
  Pending = 1,
  Rejected = 2,
  Done = 3
}
